import ConsentPrivacyPolicyCheckboxField from "./ConsentPrivacyPolicyCheckboxField";

export default ConsentPrivacyPolicyCheckboxField;
